// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image_fiYHn {
  display: grid;
  grid-template-columns: minmax(0,1fr);
  grid-template-rows: minmax(0,1fr);
  justify-content: center;
  max-width: 100%;
  position: relative;
}

.image_fiYHn > div {
  height: 100%;
  min-height: 0;
}

.noImage_jIzn_ {
  align-self: center;
  justify-content: center !important;
}

.loading_R327Q {
  width: 100%;
  height: 100%;
  background-color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

.details_im0pO > div:first-child {
  background-color: transparent;
  border: none;
  padding: 0;
  flex-grow: 1;
}

.details_im0pO {
  --size-galleryDetailTextMin: 10px;
  --size-galleryDetailTextMax: 2cqw;
  width: 100%;
  container-type: inline-size;
  overflow: hidden;
}

.details_im0pO div, .details_im0pO button {
  --details-font-size: max(var(--size-galleryDetailTextMin, 4.2cqi), var(--size-galleryDetailTextMax, 12px));
  font-size: var(--details-font-size) !important;
  --size-padMedium: 0px;
  --size-padLarge: var(--details-font-size);
}

.details_im0pO > div > div > :nth-child(1) {
  display: inline-block;
  width: 100%;
  overflow: hidden;
}

.details_im0pO > div > div > :nth-child(2) {
  grid-template-columns: auto minmax(0, 1fr) !important;
}

.timelineItemContent_MfzeR {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(0,1fr) auto;
  width: 100%;
  overflow: hidden;
}

.timelineItem_pRwLY {
  display: grid;
  grid-template-rows: auto minmax(0,1fr);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/dataViewers/timeline/viewers/resource/ResourceTimelineViewer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oCAAoC;EACpC,iCAAiC;EACjC,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0GAA0G;EAC1G,8CAA8C;EAC9C,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC","sourcesContent":[".image {\n  display: grid;\n  grid-template-columns: minmax(0,1fr);\n  grid-template-rows: minmax(0,1fr);\n  justify-content: center;\n  max-width: 100%;\n  position: relative;\n}\n\n.image > div {\n  height: 100%;\n  min-height: 0;\n}\n\n.noImage {\n  align-self: center;\n  justify-content: center !important;\n}\n\n.loading {\n  width: 100%;\n  height: 100%;\n  background-color: black;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n}\n\n.details > div:first-child {\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  flex-grow: 1;\n}\n\n.details {\n  --size-galleryDetailTextMin: 10px;\n  --size-galleryDetailTextMax: 2cqw;\n  width: 100%;\n  container-type: inline-size;\n  overflow: hidden;\n}\n\n.details div, .details button {\n  --details-font-size: max(var(--size-galleryDetailTextMin, 4.2cqi), var(--size-galleryDetailTextMax, 12px));\n  font-size: var(--details-font-size) !important;\n  --size-padMedium: 0px;\n  --size-padLarge: var(--details-font-size);\n}\n\n.details > div > div > :nth-child(1) {\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n}\n\n.details > div > div > :nth-child(2) {\n  grid-template-columns: auto minmax(0, 1fr) !important;\n}\n\n.timelineItemContent {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: minmax(0,1fr) auto;\n  width: 100%;\n  overflow: hidden;\n}\n\n.timelineItem {\n  display: grid;\n  grid-template-rows: auto minmax(0,1fr);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `image_fiYHn`,
	"noImage": `noImage_jIzn_`,
	"loading": `loading_R327Q`,
	"details": `details_im0pO`,
	"timelineItemContent": `timelineItemContent_MfzeR`,
	"timelineItem": `timelineItem_pRwLY`
};
export default ___CSS_LOADER_EXPORT___;
